import _objectWithoutProperties from "/Volumes/United_T7/projects/careersv2/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["listeners", "debug", "children", "inputRef"];
import React, { useMemo } from "react";
import { logger } from "@rpldy/shared";
import UploadyContext, { createContextApi } from "./UploadyContext";
import useUploader from "./useUploader";

var NoDomUploady = function NoDomUploady(props) {
  var listeners = props.listeners,
      debug = props.debug,
      children = props.children,
      inputRef = props.inputRef,
      uploadOptions = _objectWithoutProperties(props, _excluded);

  logger.setDebug(!!debug);
  logger.debugLog("@@@@@@ Uploady Rendering @@@@@@", props);
  var uploader = useUploader(uploadOptions, listeners);
  var api = useMemo(function () {
    return createContextApi(uploader, inputRef);
  }, [uploader, inputRef]);
  return /*#__PURE__*/React.createElement(UploadyContext.Provider, {
    value: api
  }, children);
};

export default NoDomUploady;